(function(){'use strict';
function boot(){
  var root=document.querySelector('[data-lilou-product-experience]');
  var list=root&&root.querySelector('[data-lilou-complements]');
  if(!root||!list||root.dataset.composerGenderGate==='1')return;
  root.dataset.composerGenderGate='1';

  var audience=root.dataset.audience||'';
  var collection=audience==='homme'?'univers-hommes':audience==='femme'?'univers-femmes':'';
  if(!collection)return;

  var nativeFetch=window.fetch.bind(window);
  var allowed=null;
  function engineGenericUrl(input){
    var raw=typeof input==='string'?input:(input&&input.url)||'';
    try{
      var u=new URL(raw,location.origin);
      return u.origin===location.origin&&u.pathname==='/products.json'&&u.searchParams.get('limit')==='250'&&u.searchParams.has('page');
    }catch(e){return false}
  }
  /* Le moteur validé reste intact ; ses pools génériques sont simplement enfermés dans l'univers de la fiche. */
  window.fetch=function(input,init){
    if(engineGenericUrl(input))return nativeFetch('/collections/'+collection+'/products.json?limit=250',init);
    return nativeFetch(input,init);
  };

  function ensureEmptyMessage(){
    if(list.querySelector('[data-comp-card]'))return;
    if(!list.querySelector('.lilou-no-complements'))list.innerHTML='<p class="lilou-no-complements">Aucun complément suffisamment cohérent n’est disponible pour ce look pour le moment.</p>';
  }
  function sanitize(){
    if(!allowed)return;
    var seen={};
    Array.prototype.slice.call(list.querySelectorAll('[data-comp-card]')).forEach(function(card){
      var id=String(card.getAttribute('data-product-id')||'');
      if(!id||!allowed[id]||seen[id])card.remove();else seen[id]=1;
    });
    ensureEmptyMessage();
  }

  nativeFetch('/collections/'+collection+'/products.json?limit=250',{credentials:'same-origin'})
    .then(function(r){return r.ok?r.json():{products:[]}})
    .then(function(d){
      allowed={};
      (d.products||[]).forEach(function(p){if(p&&p.id!=null)allowed[String(p.id)]=1});
      sanitize();
      new MutationObserver(sanitize).observe(list,{childList:true,subtree:true});
    })
    .catch(function(){
      /* En cas d'échec du garde-fou, mieux vaut masquer les compléments que mélanger les univers. */
      list.innerHTML='<p class="lilou-no-complements">Les compléments de ce look sont momentanément indisponibles.</p>';
    });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
